'use client';

import { CalendarDays } from 'lucide-react';
import Image from 'next/image';
import { useState } from 'react';

interface Props {
    src?: string;
    slug: string;
}

// These event slugs differ from the filenames of the bundled artwork.
const eventImageAliases: Record<string, string> = {
    'singles-day-deals': 'singles-day',
    'thanksgiving-2026': 'thanksgiving-coupons-deals',
};

const SeasonalEventThumbnail = ({ src, slug }: Props) => {
    const [failedSources, setFailedSources] = useState<string[]>([]);
    const fallbackSrc = `/shared-assets/${eventImageAliases[slug] ?? slug}.png`;
    const imageSrc = [src, fallbackSrc].find(
        (source): source is string => typeof source === 'string' && source.length > 0 && !failedSources.includes(source),
    );

    if (!imageSrc) {
        return <CalendarDays className="h-6 w-6 text-white/75" aria-hidden="true" />;
    }

    return (
        <Image
            key={imageSrc}
            src={imageSrc}
            alt=""
            width={48}
            height={48}
            className="h-full w-full object-contain p-1"
            onError={() => setFailedSources(previous => [...previous, imageSrc])}
        />
    );
};

export default SeasonalEventThumbnail;
